import { render, staticRenderFns } from "./WalletsList.vue?vue&type=template&id=6d8ddc84&scoped=true&"
import script from "./WalletsList.vue?vue&type=script&lang=js&"
export * from "./WalletsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ddc84",
  null
  
)

export default component.exports